import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {//要设置的全局访问的state对象
    color: "white",
    screen: false,
    language:null,
    width:null,
};
const store = new Vuex.Store({
    state
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js